import makeStyles from "@material-ui/core/styles/makeStyles";
import { createStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    titleBar: {
      textAlign: "start",
      backgroundColor: "#869ac4"
    },
    tabLabel: {
      fontSize: "0.9rem"
    },
    inputField: {
      width: "150px",
      marginLeft: "5px"
    },
    branchesInputField: {
      width: "400px",
      marginLeft: "5px"
    },
    radioLabel: {
      fontSize: "0.9rem"
    },
    paper: {
      width: 200,
      height: 230,
      overflow: "auto"
    },
    button: {
      margin: theme.spacing(0.5, 0)
    },
    root: {
      margin: "auto",
      width: 500,
      "& > * + *": {
        marginTop: theme.spacing(3)
      }
    },
    errorMsg: {
      width: "150px",
      marginLeft: "5px",
      color: "red"
    }
  })
);
